import { render } from "./socialGeneral.vue?vue&type=template&id=573a3692"
import script from "./socialGeneral.vue?vue&type=script&lang=js"
export * from "./socialGeneral.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__